const pattern = /\[([^|\]]+)\|([^|\]]+)\]/;

export default pattern;